/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './Dashboard.css';
import Globals from "../../shared/Globals";
import GaugeChart from 'react-gauge-chart';
import { qreq } from "../../shared/qrequest";
import Card from "../Card";


class MnfDashboard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    async componentDidMount() {
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        await this.getSettings();
        await this.getMainOrg();
        await this.loadProducts();
        
    }

    loadProducts = async () => {
        try {

            let j = await qreq.getAsync('/api/product/list');
            if (j.list) {
                this.setState({ productList: j.list });
                await this.loadStock(j.list);
            }
        }
        catch (e) {

        }
    }

    loadStock = async (products) => {
        try {

            let j = await qreq.getAsync('/api/inventory/instock');
            if (j.list) {
                this.setState({ stockList: j.list });
                this.processList(products, j.list);
            }
        }
        catch (e) {

        }
    }

    processList = (productList,stockList) => {
        productList.forEach(p => {
            let find = stockList.find(x => x.productID === p.id);
            if(find)
                p.inStock = find.counter;
            else
                p.inStock = 0;
            p.__percent = parseFloat(p.inStock/p.lowStockAlarmThresh);
            if(p.__percent > 1)
                p.__percent = 1;
        });
        this.setState({ productList });
    }

    render() {
        return <div className="Dashboard container-fluid">
            <h1>Dashboard</h1>
            <h2>Good <span>{Globals.getTimeOfDay()}</span> {this.state.user?.name}!</h2>

            <div className="row">
                {this.state.productList?.filter(x => x.lowStockAlarm).map((p, pdx) => (
                    <div className="col-lg-3 col-6 mt-3 text-center" key={pdx}>
                        <Card>
                            <div><small className="text-primary">{p.nameWithSize}</small></div>
                            <GaugeChart
                                nrOfLevels={p.lowStockAlarmThresh}
                                percent={p.__percent || 0}
                                arcPadding={0.02}
                                needleColor={this.state.org?.primaryColor}
                                arcsLength={[0.1, 0.9]}
                                colors={['#b82929ff', '#32ad32ff']}
                                hideText
                            />
                            <div>{p.inStock || '0'}/<span className="text-muted">{p.lowStockAlarmThresh}</span></div>
                        </Card>
                    </div>
                ))}
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(MnfDashboard);